// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from "./languages/english.json";
import translationFrench from "./languages/french.json";

const resources = {
  0: {
    translation: translationEnglish,
  },
  1: {
    translation: translationFrench,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("selectedLanguage") ?? "1",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
